const MAX_AVAILABLE_CALL_QUOTA = 10;
const REPLENISH_INTERVAL_MS = 5000;

export const createRateLimiter = (maxQuota = MAX_AVAILABLE_CALL_QUOTA) => {
	let callQuota = maxQuota;

	setInterval(() => {
		callQuota = Math.min(callQuota + 1, maxQuota);
	}, REPLENISH_INTERVAL_MS);

	const consume = () => {
		if (callQuota <= 0) return false;
		callQuota--;
		return true;
	};

	return { consume };
};
